import { Inject, Injectable } from '@angular/core';


import { QueryService } from 'src/app/core/services/query.service';

import { CrudFluxService } from 'src/app/core/services/crud-flux.service';
import { ApiFluxService } from 'src/app/core/services/api-flux.service';
import { SnackbarService } from 'src/app/core/services/snackbar-psa.service';

import { CRUD_FILE_ENDPOINT, CRUD_FILE_QUERY_SERVICE_INSTANCE, CRUD_FORM_ENDPOINT } from './test-api.config';

import { FileForm } from './test-api.model';
import { map, Subject, tap } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class TestApiService extends CrudFluxService<FileForm> {

  constructor(
    @Inject(CRUD_FILE_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<FileForm>,
    public readonly apiService:ApiFluxService,
    protected  override readonly snackbar : SnackbarService
    //@Inject(SnackbarService) protected override readonly snackbar: SnackbarService

  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(CRUD_FILE_ENDPOINT, apiService, snackbar);
  }

 get<FileForm>(id:string){
  return this.apiService.get<FileForm>(`${CRUD_FILE_ENDPOINT}/${id}`).pipe(
    map(({ secondResponse }) => secondResponse.body)
  );
  }
  getAllFiles<FileForm>(idPsa:string){
    return this.apiService.get<FileForm>(`${CRUD_FILE_ENDPOINT}/${idPsa}/list`).pipe(
      map(({ secondResponse }) => secondResponse.body)
    );
    }

  getForm(id:number | string){
    return this.apiService.get<any>(`${CRUD_FORM_ENDPOINT}/${id}`).pipe(
          map(({ secondResponse }) => secondResponse.body)
    );
  }

  saveFile(dati: any) {
    let saved: Subject<any> = new Subject<any>();
    this.apiService.post(`${CRUD_FILE_ENDPOINT}/upload`, dati).pipe(
      map(({ secondResponse }) =>{ 
        if (secondResponse.status === 200) {
          this.snackbar.open('Dati salvati con successo!', 'close');
        }
        return secondResponse.body
      })
    ).subscribe({
      next: value => saved.next(value),
      error: err => saved.error(err),
      complete: () => saved.complete(),
      
    });
    return saved.asObservable();
  }

  saveForm(dati: any) {
    return this.apiService.post(`${CRUD_FORM_ENDPOINT}`, dati).pipe(
      tap(({ firstResponse, secondResponse }) => {
        console.log("Prima risposta:", firstResponse);
        console.log("Seconda risposta:", secondResponse);
        if (secondResponse.status === 200) {
          this.snackbar.open('Dati salvati con successo!', 'close');
        }
      }),
    );
  }
  

}
